<app-leveltwo [videos]="true" [pageName]="'Business Property Statement Filing'">
    <div heading="General Info" class="General">
      <h3>{{'BusinessFiling.PageTitle'|translate}}</h3>

      <p>{{'BusinessFiling.Eachyear'|translate}}</p>
      <p>{{'BusinessFiling.Generally'|translate}}</p>
      <p [innerHTML]="'BusinessFiling.Youcan'|translate"></p>
      <!--
      <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622783798/Form/BOE-571-L.pdf" type="button" class="btn btn-primary" target="_blank">{{'BusinessFiling.downloadform'|translate}}</a>
        <br><br>-->
        <a href="https://efile.assessor.lacounty.gov/efilela/main.jsp" type="button" class="btn btn-primary" target="_blank">{{'BusinessFiling.efile'|translate}}</a>

      <br><br>
      <!-- 3 Column section -->
      <div class="row">
        <div class="col-sm">
          <h4 style="font-weight:bold">{{'BusinessFiling.Whatis'|translate}}</h4>
          <p>{{'BusinessFiling.Whatistext1'|translate}}</p>
          <p>{{'BusinessFiling.Whatistext2'|translate}}</p>
          <ul>
            <li>{{'BusinessFiling.Whatisitem1'|translate}}</li>
            <li>{{'BusinessFiling.Whatisitem2'|translate}}</li>
            <li>{{'BusinessFiling.Whatisitem3'|translate}}</li>
            <li>{{'BusinessFiling.Whatisitem4'|translate}}</li>
            <li>{{'BusinessFiling.Whatisitem5'|translate}}</li>
            <li>{{'BusinessFiling.Whatisitem6'|translate}}</li>
          </ul>
          <p>{{'BusinessFiling.Whatistext3'|translate}}</p>
          <p>{{'BusinessFiling.Whatistext4'|translate}}</p>
        </div>
        <div class="col-sm">
          <h4 style="font-weight:bold">{{'BusinessFiling.Businesspropstatement'|translate}}</h4>
          <p><b>{{'BusinessFiling.571-LForms'|translate}}</b></p>

          <ul>
            <li>{{'BusinessFiling.busiprop1'|translate}}</li>
            <li>{{'BusinessFiling.busiprop2'|translate}}</li>
            <li>{{'BusinessFiling.busiprop3'|translate}}</li>
            <li>{{'BusinessFiling.busiprop4v2'|translate}}</li>
            <li>{{'BusinessFiling.busiprop5'|translate}}</li>
          </ul>

        </div>
        <div class="col-sm">
          <h4 style="font-weight:bold">{{'BusinessFiling.Leaseequipment'|translate}}</h4>
          <p>{{'BusinessFiling.boththelessor'|translate}}</p>
          <ul>
            <li>{{'BusinessFiling.leaseitem1'|translate}}</li>
            <li>{{'BusinessFiling.leaseitem2'|translate}}</li>
            <li>{{'BusinessFiling.leaseitem3'|translate}}</li>
            <!--
            <li>{{'BusinessFiling.leaseitem4'|translate}}</li>
            -->
            <li>{{'BusinessFiling.leaseitem5'|translate}}</li>
          </ul>
        </div>
      </div>

    </div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
